import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) return toast.error(error.message);
    toast.success("Password updated");
    navigate("/app");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FAF8F5] p-6">
      <div className="max-w-md w-full bg-white rounded-3xl border border-[#E8E2D9] p-10" data-testid="reset-page">
        <h1 className="font-display font-bold text-2xl tracking-tight mb-2">Set a new password</h1>
        <p className="text-sm text-[#57534E] mb-6">Choose a strong password with at least 8 characters.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="pw">New password</Label>
            <Input id="pw" data-testid="reset-password" type="password" required minLength={8}
                   value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5" />
          </div>
          <Button data-testid="reset-submit" type="submit" disabled={loading}
                  className="w-full rounded-full bg-[#E8712C] hover:bg-[#C55A1F]">
            {loading ? "Updating…" : "Update password"}
          </Button>
        </form>
      </div>
    </div>
  );
}
